// 立即从localStorage恢复token，确保刷新页面时token立即可用
const initialToken = localStorage.getItem('token') || ''

const state = {
  token: initialToken,
  user: null,
  enterpriseInfo: null,
  isAuthenticated: !!initialToken
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    state.isAuthenticated = !!token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER(state, user) {
    state.user = user
  },
  SET_ENTERPRISE_INFO(state, enterpriseInfo) {
    state.enterpriseInfo = enterpriseInfo
  },
  LOGOUT(state) {
    state.token = ''
    state.user = null
    state.enterpriseInfo = null
    state.isAuthenticated = false
    localStorage.removeItem('token')
  }
}

const actions = {
  async login({ commit, rootState }, { token, user }) {
    localStorage.removeItem('user')
    localStorage.removeItem('enterpriseInfo')
    
    commit('SET_TOKEN', token)
    commit('SET_USER', user)
    
    // 发送登录同步消息
    if (rootState.authSync) {
      rootState.authSync.sendLoginSync(token, user)
    }
  },
  logout({ commit, rootState }) {
    commit('LOGOUT')
    
    // 发送退出同步消息
    if (rootState.authSync) {
      rootState.authSync.sendLogoutSync()
    }
  },
  async syncUser({ commit, state }) {
    const token = localStorage.getItem('token')
    
    if (token) {
      if (!state.token) {
        commit('SET_TOKEN', token)
      }
      
      try {
        const { authAPI } = await import('@/utils/api')
        const res = await authAPI.getUserInfo()
        
        let userData = null
        if (res && res.data) {
          userData = res.data
        } else if (res && res.username) {
          userData = res
        }
        
        if (userData) {
          commit('SET_USER', userData)
        } else {
          commit('LOGOUT')
        }
      } catch (e) {
        // 静默处理401错误（未登录是正常情况，不需要记录错误）
        if (e.response?.status !== 401) {
          console.error('同步用户信息失败:', e)
        }
        // 对于401错误，需要更谨慎处理
        // 在生产环境中，可能是token过期或无效，但也可能是网络问题
        // 只有在明确是认证失败时才清除token
        if (e.response?.status === 401) {
          // 检查是否是真正的认证失败（不是网络问题）
          // 如果响应中有明确的认证错误信息，才清除token
          const errorMessage = e.response?.data?.message || e.response?.data?.detail || ''
          const isAuthFailure = errorMessage.includes('token') || 
                                errorMessage.includes('认证') || 
                                errorMessage.includes('登录') ||
                                errorMessage.includes('unauthorized') ||
                                errorMessage.includes('expired')
          
          if (isAuthFailure) {
            console.log('⚠️ 同步用户信息时遇到401认证错误，清除token，需要重新登录')
            commit('LOGOUT')
          } else {
            // 可能是网络问题或其他原因，保留token，不立即清除
            console.log('⚠️ 同步用户信息时遇到401错误，但可能是网络问题，保留token')
          }
        } else {
          // 非401错误（如网络错误），保留登录状态
          // 因为可能是网络问题，不是token问题
          console.log('⚠️ 同步用户信息失败，但保留登录状态，可能是网络问题')
        }
      }
    } else {
      commit('LOGOUT')
    }
  }
}

const getters = {
  isAuthenticated: state => state.isAuthenticated,
  user: state => state.user,
  token: state => state.token,
  enterpriseInfo: state => state.enterpriseInfo
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



